import { Expose } from "class-transformer";

export class UpdateGeneralDocumentDto {
  @Expose()
  name: string;

  @Expose()
  id: string;
}
